import React from 'react';
import PropTypes from 'prop-types';

import {LOADING} from 'src/shared/currentView/commonViews';
import {SMS_ENROLLED, SMS_ENROLLMENT, ERROR_SCREEN} from 'src/pages/reportIssue/constants/views';
import {LoadingScreen} from 'src/pages/reportIssue/components/LoadingScreen';
import {SmsConfirmedScreen} from 'src/pages/reportIssue/components/SmsConfirmedScreen';
import {SmsEnrollmentScreen} from 'src/pages/reportIssue/components/SmsEnrollmentScreen';
import {ErrorScreen} from 'src/pages/reportIssue/components/ErrorScreen';

import 'src/pages/reportIssue/components/base.scss';

export const Page = ({
  continueUrl,
  currentView,
  enrollSms,
  scheduleCallbackUrl,
  smsNumber,
  statusCenterUrl,
}) =>
  <>
    <main>
      {(() => {
        switch (currentView) {
          case SMS_ENROLLED:
            return <SmsConfirmedScreen statusCenterUrl={statusCenterUrl} smsNumber={smsNumber} />;
          case SMS_ENROLLMENT:
            return <SmsEnrollmentScreen continueUrl={continueUrl} enrollSms={enrollSms} />;
          case ERROR_SCREEN:
            return <ErrorScreen scheduleCallbackUrl={scheduleCallbackUrl} />;
          case LOADING:
          default:
            return <LoadingScreen />;
        }
      })()}
    </main>
  </>;

Page.propTypes = {
  continueUrl: PropTypes.string.isRequired,
  currentView: PropTypes.string.isRequired,
  scheduleCallbackUrl: PropTypes.string.isRequired,
  enrollSms: PropTypes.func.isRequired,
  smsNumber: PropTypes.string,
  statusCenterUrl: PropTypes.string.isRequired,
};
